export const fetchAllReviews = () => (
  $.ajax({
    type: "GET",
    url: "/fetch_google_reviews"
  })
);